import qs from 'query-string'
import { useTranslation } from 'react-i18next'

import { isIOS } from 'lib/device'

import { Link } from 'features/i18n/router'
import useGetReviews from 'features/UserReviews/hooks/useGetReviews'
import { useCurrentUser } from 'store/api/yay/user'

import { UserReviewList } from '../UserReviewList'

const UserReviewListModal = (props) => {
  const { t } = useTranslation()
  const userId = qs.parse(props.location.search)?.userId as string
  const { data: currentUser } = useCurrentUser()

  const {
    combinedResults,
    isLoading,
    onLoadMore,
    shouldLoadMore,
    loadMoreRef,
  } = useGetReviews(userId, true)

  return (
    <div
      className="Modal__wrapper"
      style={isIOS ? { height: window.innerHeight } : {}}
    >
      <div className="Modal__header">
        <Link className="Modal__header__close" to={props.location.pathname} />

        <h2 className="Modal__header__h2">
          {t('user_review_list_modal.title')}
        </h2>
      </div>

      <div className="Modal__body">
        <UserReviewList
          isLoading={isLoading}
          reviews={combinedResults}
          isSelfUserReview={parseInt(userId, 10) === currentUser?.id}
          onLoadMore={onLoadMore}
          hasLoadMore={shouldLoadMore}
          loadMoreRef={loadMoreRef}
          disablePinMenu
        />
      </div>
    </div>
  )
}

export default UserReviewListModal
